import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { debounceTime, map, startWith } from 'rxjs/operators';
import { has, or } from 'shared/criteria/Criteria';
import { FilterSource } from 'shared/modules/table/table-utils/table-directives';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SearchComponent extends FilterSource<string> implements OnInit {
  search = new UntypedFormControl('');

  @Input() appearance: 'fill' | 'outline' = 'fill';
  private customLabel?: string;

  constructor(private translateService: TranslateService) { super(); }

  @Input()
  set label(value: string | undefined) { this.customLabel = value; }

  get label(): string { return this.customLabel ?? this.translateService.instant('COMMON.search'); }
  @Input() field: string | string[] = '';
  @Input() delay = 700;

  // Если поиск строится на фильтрации данных из Store, то ставим true
  @Input() localeSearch = false;

  ngOnInit(): void {
    this.search.valueChanges
      .pipe(
        startWith(''),
        debounceTime(this.delay),
        map((value) => {
          if (!value) {
            return '';
          }

          if (this.localeSearch) {
            return value;
          }

          return Array.isArray(this.field)
            ? or(...this.field.map(field => has.text(field, value)))
            : has.text(this.field, value);
        }),
      )
      .subscribe(filter => this.filterChanged.emit(filter));
  }
}
